import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { v4 as uuidv4 } from "uuid";
import { checkStorePermission, checkSurveyQuiz, markSurveyQuizSnoozed } from '../../redux/authentication/actionCreator';
import PermissionDenied from '../../layout/PermissionDenied';
import Spinner from './Spinner';
import TVPanelBlock from '../dashboard/TVPanelBlock';

const SURVEY_UNIQUE_TOKEN_KEY = "survey_unique_token";
const SURVEY_SNOOZE_UNTIL_KEY = "survey_snooze_until";

export const isFullStoreLock = (lockType) => {
    return lockType === 'overall';
};

export const getSurveyUniqueToken = () => {
    const existingToken = localStorage.getItem(SURVEY_UNIQUE_TOKEN_KEY);
    if (existingToken) {
        return existingToken;
    }

    const uniqueToken = uuidv4();
    localStorage.setItem(SURVEY_UNIQUE_TOKEN_KEY, uniqueToken);
    return uniqueToken;
};

const isSurveySnoozed = () => {
    const snoozeUntil = Number(localStorage.getItem(SURVEY_SNOOZE_UNTIL_KEY) || 0);
    return snoozeUntil > Date.now();
};

const getSurveySnoozeRemaining = () => {
    const snoozeUntil = Number(localStorage.getItem(SURVEY_SNOOZE_UNTIL_KEY) || 0);
    return Math.max(snoozeUntil - Date.now(), 0);
};

const RouteGate = ({ children, router }) => {
    const dispatch = useDispatch();
    const { pathname } = useLocation();
    const { status = 'idle', allowed = null, error = null, router: checkedRouter = null, lockType = '', details = null, isTvDownloaded = null } = useSelector((storePermission) => storePermission.storePermission || {});
    const surveyQuiz = useSelector((state) => state.surveyQuiz || {});
    const isTvDownloadBlocked = status === 'succeeded' && checkedRouter === router && (isTvDownloaded === true || isTvDownloaded === 'true' || isTvDownloaded === 1 || isTvDownloaded === '1');

    useEffect(() => {
        let active = true;
        let snoozeTimer = null;
        if (router) {
            const uniqueToken = getSurveyUniqueToken();
            dispatch(checkStorePermission(router)).then((allowed) => {
                if (active && allowed) {
                    if (isSurveySnoozed()) {
                        dispatch(markSurveyQuizSnoozed(uniqueToken, router));
                        snoozeTimer = setTimeout(() => {
                            dispatch(checkSurveyQuiz(uniqueToken, router));
                        }, getSurveySnoozeRemaining());
                    } else {
                        dispatch(checkSurveyQuiz(uniqueToken, router));
                    }
                }
            });
        }

        return () => {
            active = false;
            if (snoozeTimer) {
                clearTimeout(snoozeTimer);
            }
        };
    }, [dispatch, router, pathname]);

    if (status === 'loading' || status === 'idle' || checkedRouter !== router) {
        return <Spinner size={40} ringSize={100} />;
    }

    if (status === 'failed' || allowed === false) {
        return isFullStoreLock(lockType) ? (
            <PermissionDenied title="Locked" message="This portal is locked by HO." details={details} locked />
        ) : (
            <PermissionDenied title="Portal Locked" message={error} details={details} locked/>
        );
    }

    if (isTvDownloadBlocked) {
        return <TVPanelBlock />;
    }

    if (surveyQuiz?.status === 'loading' || surveyQuiz?.status === 'idle' || surveyQuiz?.router !== router) {
        return <Spinner size={40} ringSize={100} />;
    }

    return <>{children}</>;
};

export default RouteGate;
 
